import React, { useState, useEffect } from 'react';
import { Grid, TextField } from '@mui/material';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import APIService from '../../../../APIService';
import swal from 'sweetalert';
import { useParams } from 'react-router';

export default function StartupPhoto() {

  const params = useParams();
  const thumbnailId = params.id;

  const [startups, setStartups] = useState([]);
  const [caption, setCaption] = useState("");
  const [description, setDescription] = useState("");
  const [fileUpload, setFileUpload] = useState("");

  const [startupId, setStartupId] = useState("");
  const [isEditing, setIsEditing] = useState(false);


  useEffect(() => {
    APIService.get('startup_thumbnail/' + thumbnailId).then((response) => {
      setStartups(response.data);
    })
  }, []);

  const handleFileChange = (e) => {
    if (e.target.files) {
      setFileUpload(e.target.files[0]);
    }
  }

  const handleEdit = (itemId, caption, description) => {
    setStartupId(itemId);
    setIsEditing(true);
    setCaption(caption);
    // setDescription(description)
  }

  const handleDelete = (itemId) => {

    // e.preventDefault();
    swal({
      title: "Are you sure?",
      text: "You want to delete this item?",
      icon: "warning",
      dangerMode: true,
    })
      .then(willDelete => {
        if (willDelete) {
          APIService.delete(`startup/${itemId}`)
            .then(response => {
              swal("Success", response.message, "success", {
                buttons: false,
                timer: 2000,
              }).then((value) => {
                window.location.href = "/startup/" + thumbnailId;
              });
            });
        }
      });
  }


  const handleSubmit = async (e) => {

    e.preventDefault();
    const formData = new FormData();

    formData.append("caption", caption);
    // formData.append("description", description);
    formData.append("thumbnail_id", thumbnailId);
    formData.append("file_upload", fileUpload);

    if (isEditing) {

      var response = await APIService.put(formData, `startup/${startupId}`);
    } else {

      var response = await APIService.post(formData, 'startup');
    }

    if (response.success) {

      swal("Success", response.message, "success", {
        buttons: false,
        timer: 2000,
      }).then((value) => {

        window.location.href = "/startup/" + thumbnailId;
      });
    } else {

      swal("Failed", response.message, "error");
    }
  }

  return (
    <div>

      <form noValidate onSubmit={handleSubmit}>
        <h3 className='mt-4'>Photo Upload (Startup Entrepreneurship)</h3>
        <Grid container spacing={3} style={{ marginTop: 10 }}>
          <Grid item xs={12} sm={6} lg={4}>
            <p id="labels">Caption</p>
            <TextField
              name="Caption"
              label="Caption"
              variant="outlined"
              fullWidth
              value={caption}
              onChange={e => setCaption(e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6} lg={4} style={{ marginTop: 30 }} >
          <p id="labels">Upload Image</p>
          <TextField
            name="upload-photo"
            type="file"
            onChange={handleFileChange}
          />
        </Grid>
        {/* <Grid item xs={12} sm={6} lg={12} md={8} style={{ marginTop: 30 }}>
          <p id="labels">Decription</p>
          <TextField
            fullWidth
            id="outlined-multiline-static"
            label="Decription"
            multiline
            value={description}
            rows={3}
          />
        </Grid> */}
        <Button style={{ marginTop: 20 }} variant="primary" type="submit">Upload</Button>{' '}
      </form>

      <h3>Photo List</h3>

      <Table responsive="sm mt-5">
        <thead>
          <tr>
            <th>Sr.No</th>
            <th>Photo Caption</th>
            {/* <th>Description</th> */}
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {startups.map((startup, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{startup.caption}</td>
              {/* <td>{startup.description}</td> */}
              <td><button className='tablebutton'
                onClick={() => handleEdit(startup.id, startup.caption, startup.description)}>Edit</button></td>
              <td><button className='tablebutton'
                onClick={() => handleDelete(startup.id)}>Delete</button></td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  )
}
